// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"5052":"24056b2fdbbab9c3","7815":"cf9c9ad17625d86e"}[chunkId] + ".css";
};